import store from "../store";
import { dayDiff } from "../functions/helpers";
import get from "lodash/get";

export default {
  install(Vue) {
    Vue.prototype.$user = new Vue({
      store,
      computed: {
        user() {
          return get(this.$store, "state.user.user");
        },
        myCourses() {
          return get(this.$store, "state.user.myCourses");
        },
        cof() {
          return get(this.user, "my_courses[0]");
        },
        hasCof() {
          return get(this.myCourses, get(this.cof, "id"));
        },
        service() {
          return get(this.user, "service");
        },
        isInactive() {
          return (
            this.user && (!this.service.is_active || this.daysToExpire < 0)
          );
        },
        daysToExpire() {
          if (!this.user || !this.service) return "";
          return dayDiff(this.service.expired_at);
        }
      }
    });
  }
};
